import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "required"];
import React, { forwardRef } from 'react';
import { node, string, bool } from 'prop-types';
import classNames from 'classnames';
import { InputLabel as MuiInputLabel } from '@material-ui/core';
import useInputLabelStyles from './InputLabel.styles';
const InputLabel = /*#__PURE__*/forwardRef(function InputLabel(props, ref) {
  // don't pass the required prop to avoid adding an * symbol, not in Propulsion specs
  const {
      children,
      className,
      required
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const classes = useInputLabelStyles();
  return /*#__PURE__*/React.createElement(MuiInputLabel, Object.assign({}, otherProps, {
    className: classNames('pds-input-label', className),
    classes: classes,
    disableAnimation: true,
    ref: ref,
    shrink: false
  }), children, required ? '' : ' (Optional)');
});
InputLabel.propTypes = {
  /**
   * The contents of the `InputLabel`.
   */
  children: node,
  /**
   * The CSS class name applied to the root node.
   */
  className: string,
  /**
   * If `true`, apply disabled class.
   */
  disabled: bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: bool,
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: bool
};
export default InputLabel;